import React from 'react';
import { Form, Select, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { getVSphereVersionsList } from '../../../../../lib/helpers';

let defaultValue;

const versionOptions = getVSphereVersionsList().map((v) => {
    if (v.default_value) {
        defaultValue = v.version;
    }
    return {
        label: v.label,
        value: v.version,
    };
});

export const VSphereVersionField = ({ value, onChange, disabled = false, error }) => {
    return (
        <Form.Item
            label={
                <span>
                    vSphere Version{' '}
                    <Tooltip title="Provide a version for your destination cloud.">
                        <QuestionCircleOutlined />
                    </Tooltip>
                </span>
            }
            validateStatus={error ? 'error' : ''}
            help={error}
        >
            <Select
                defaultValue={value || defaultValue}
                options={versionOptions}
                onChange={onChange}
                disabled={disabled}
                placeholder="Select vSphere version"
            />
        </Form.Item>
    );
};
